import { Union, Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { union_type, array_type, class_type, int32_type, string_type, record_type, bool_type, option_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { NewEvent, Region_$reflection, User_$reflection, Course_$reflection } from "../Shared/SharedModels.jsx";
import { tap, PromiseBuilder__TryFinally_7D49A2FD, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { successToast, errorToast } from "../Toasts.jsx";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { Event$, toastServerError, Region, User, Course } from "../ApiClient.jsx";
import { Result_ToOption } from "../fable_modules/fable-library-js.4.29.0/Result.js";
import { orElseWith, toArray, unwrap, map, defaultArg, orElse, bind, map3 } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { useCtx, ContextMsg } from "../Context.jsx";
import { toString, minute, hour, day, month, utcNow, year, create, now, compare, toUniversalTime } from "../fable_modules/fable-library-js.4.29.0/Date.js";
import { createElement } from "react";
import React from "react";
import { Spinner, Caption1, Textarea, Avatar, Combobox, Divider, Switch, Input, SpinButton, Text as Text$, Option, Dropdown, Field, DialogContent, Title3, DialogTitle, DialogBody, DialogSurface, Button, DialogTrigger, Dialog as Dialog_1, Caption1Strong, tokens, Image } from "@fluentui/react-components";
import { numberHash, comparePrimitives, equals, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { WarningRegular, DismissRegular, InfoRegular, AddRegular, CalendarLtrRegular } from "@fluentui/react-icons";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_1, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { append as append_1, contains, sortBy, map as map_1, tryFind } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { take, length, map as map_2, forAll, iterate, tryHead, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { isNumber } from "../fable_modules/fable-library-js.4.29.0/Char.js";
import { parse } from "../fable_modules/fable-library-js.4.29.0/Int32.js";
import { Component } from "../AddressSearch.jsx";
import { datePickerStrings, UserSearchBox } from "../Helpers.jsx";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import { nb } from "date-fns/locale";
import { setHours, format as format_3 } from "date-fns";
import { TimePicker } from "@fluentui/react-timepicker-compat";
import { TimeSelectionDataModule_parse } from "../fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";

class Model extends Record {
    constructor(Form, Prerequisites, IsOpen, IsSending, IsFetchingPrerequisites) {
        super();
        this.Form = Form;
        this.Prerequisites = Prerequisites;
        this.IsOpen = IsOpen;
        this.IsSending = IsSending;
        this.IsFetchingPrerequisites = IsFetchingPrerequisites;
    }
}

function Model_$reflection() {
    return record_type("AddEvent.Model", [], Model, () => [["Form", option_type(NewEventForm_$reflection())], ["Prerequisites", option_type(EventPrerequisites_$reflection())], ["IsOpen", bool_type], ["IsSending", bool_type], ["IsFetchingPrerequisites", bool_type]]);
}

class NewEventForm extends Record {
    constructor(Name, Enabled, Summary, Description, Address, MaxAttendees, Time, EndTime, SignupDeadline, TeacherId, SecondaryTeacherIds, CourseId, RegionId) {
        super();
        this.Name = Name;
        this.Enabled = Enabled;
        this.Summary = Summary;
        this.Description = Description;
        this.Address = Address;
        this.MaxAttendees = (MaxAttendees | 0);
        this.Time = Time;
        this.EndTime = EndTime;
        this.SignupDeadline = SignupDeadline;
        this.TeacherId = TeacherId;
        this.SecondaryTeacherIds = SecondaryTeacherIds;
        this.CourseId = (CourseId | 0);
        this.RegionId = RegionId;
    }
}

function NewEventForm_$reflection() {
    return record_type("AddEvent.NewEventForm", [], NewEventForm, () => [["Name", string_type], ["Enabled", bool_type], ["Summary", string_type], ["Description", option_type(string_type)], ["Address", option_type(string_type)], ["MaxAttendees", int32_type], ["Time", class_type("System.DateTime")], ["EndTime", class_type("System.DateTime")], ["SignupDeadline", class_type("System.DateTime")], ["TeacherId", option_type(int32_type)], ["SecondaryTeacherIds", array_type(int32_type)], ["CourseId", int32_type], ["RegionId", option_type(int32_type)]]);
}

class EventPrerequisites extends Record {
    constructor(AllCourses, AllValidTeachers, AllRegions) {
        super();
        this.AllCourses = AllCourses;
        this.AllValidTeachers = AllValidTeachers;
        this.AllRegions = AllRegions;
    }
}

function EventPrerequisites_$reflection() {
    return record_type("AddEvent.EventPrerequisites", [], EventPrerequisites, () => [["AllCourses", array_type(Course_$reflection())], ["AllValidTeachers", array_type(User_$reflection())], ["AllRegions", array_type(Region_$reflection())]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateForm", "UpdatePrerequisites", "UpdateIsOpen", "UpdateIsSending", "UpdateIsFetchingPrerequisites"];
    }
}

function Msg_$reflection() {
    return union_type("AddEvent.Msg", [], Msg, () => [[["Item", option_type(NewEventForm_$reflection())]], [["Item", option_type(EventPrerequisites_$reflection())]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Form, msg.fields[0], model.IsOpen, model.IsSending, model.IsFetchingPrerequisites);
        case 2:
            return new Model(model.Form, model.Prerequisites, msg.fields[0], model.IsSending, model.IsFetchingPrerequisites);
        case 3:
            return new Model(model.Form, model.Prerequisites, model.IsOpen, msg.fields[0], model.IsFetchingPrerequisites);
        case 4:
            return new Model(model.Form, model.Prerequisites, model.IsOpen, model.IsSending, msg.fields[0]);
        default:
            return new Model(msg.fields[0], model.Prerequisites, model.IsOpen, model.IsSending, model.IsFetchingPrerequisites);
    }
}

function init() {
    return new Model(undefined, undefined, false, false, true);
}

function Promises_fetchPrerequisites(dispatch, setCtx) {
    let pr_4;
    const pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => PromiseBuilder__TryFinally_7D49A2FD(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr, pr_1, pr_2;
        return (Promise.all([((pr = tap((res) => {
            if (res.tag === 1) {
                errorToast(setCtx, "fetchCoursesError", "Kunne ikke hente kurs", "", undefined);
            }
        }, startAsPromise(Course.GetAllCourses())), pr.then(Result_ToOption))), ((pr_1 = tap((res_1) => {
            if (res_1.tag === 1) {
                errorToast(setCtx, "fetchUsersError", "Kunne ikke hente brukere", "", undefined);
            }
        }, startAsPromise(User.GetAllTeachers())), pr_1.then(Result_ToOption))), ((pr_2 = tap((res_2) => {
            if (res_2.tag === 1) {
                errorToast(setCtx, "fetchRegionsError", "Kunne ikke hente regioner", "", undefined);
            }
        }, startAsPromise(Region.GetAllRegions())), pr_2.then(Result_ToOption)))])).then((_arg) => {
            dispatch(new Msg(1, [map3((courses$0027, users$0027, regions$0027) => (new EventPrerequisites(courses$0027, users$0027, regions$0027)), _arg[0], _arg[1], _arg[2])]));
            return Promise.resolve();
        });
    }), () => {
        dispatch(new Msg(4, [false]));
    })));
    pr_4 = (pr_3.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
    void pr_4;
}

function Promises_addEvent(form, appendEvent, dispatch, setCtx) {
    const matchValue = form.Address;
    const matchValue_1 = form.TeacherId;
    const matchValue_2 = form.RegionId;
    let matchResult, address, regionId, teacherId;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            if (matchValue_2 != null) {
                matchResult = 0;
                address = matchValue;
                regionId = matchValue_2;
                teacherId = matchValue_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const pr = tap((res) => {
                let tupledArg;
                dispatch(new Msg(3, [false]));
                if (res.tag === 1) {
                    switch (res.fields[0].tag) {
                        case 1: {
                            errorToast(setCtx, "addEventEmptyName", "Kunne ikke legge til arrangement", "Navn kan ikke være tomt", undefined);
                            break;
                        }
                        case 2: {
                            errorToast(setCtx, "addEventEmptySummary", "Kunne ikke legge til arrangement", "Sammendrag kan ikke være tomt", undefined);
                            break;
                        }
                        case 3: {
                            errorToast(setCtx, "addEventEmptyAddress", "Kunne ikke legge til arrangement", "Adresse kan ikke være tom", undefined);
                            break;
                        }
                        case 4: {
                            errorToast(setCtx, "addEventInvalidTeacher", "Kunne ikke legge til arrangement", "Ugyldig kursholder", undefined);
                            break;
                        }
                        case 5: {
                            errorToast(setCtx, "addEventInvalidCourse", "Kunne ikke legge til arrangement", "Ugyldig kurs", undefined);
                            break;
                        }
                        case 6: {
                            errorToast(setCtx, "addEventInvalidRegion", "Kunne ikke legge til arrangement", "Ugyldig region", undefined);
                            break;
                        }
                        case 7: {
                            errorToast(setCtx, "addEventInvalidTime", "Kunne ikke legge til arrangement", "Ugyldig tid/dato", undefined);
                            break;
                        }
                        case 8: {
                            errorToast(setCtx, "addEventInvalidDeadline", "Kunne ikke legge til arrangement", "Ugyldig påmeldingsfrist", undefined);
                            break;
                        }
                        case 9: {
                            errorToast(setCtx, "addEventInvalidSecondaryTeacher", "Kunne ikke legge til arrangement", "Ugyldig sekundær kursholder", undefined);
                            break;
                        }
                        case 10: {
                            errorToast(setCtx, "addEventPrimaryTeacherInSecondaryList", "Kunne ikke legge til arrangement", "Primær kursholder kan ikke være sekundær kursholder", undefined);
                            break;
                        }
                        default:
                            errorToast(setCtx, "addEventNegativeMaxAttendees", "Kunne ikke legge til arrangement", "Antall plasser kan ikke være negativt", undefined);
                    }
                }
                else {
                    const e = res.fields[0];
                    appendEvent(e);
                    successToast(setCtx, "addEventSuccess", "Arrangement lagt til", `Arrangementet ${e.Name} ble lagt til`);
                    dispatch(new Msg(2, [false]));
                    dispatch(new Msg(0, [undefined]));
                    setCtx((tupledArg = [e.Id, e.Name], new ContextMsg(7, [tupledArg[0], tupledArg[1]])));
                }
            }, startAsPromise(Event$.Add(new NewEvent(form.Name, form.Enabled, form.Summary, form.Description, address, form.MaxAttendees, toUniversalTime(form.Time), toUniversalTime(form.EndTime), toUniversalTime(form.SignupDeadline), teacherId, form.SecondaryTeacherIds, form.CourseId, regionId))));
            void (pr.catch((arg) => {
                const _arg = toastServerError(setCtx, arg);
                dispatch(new Msg(3, [false]));
            }));
            break;
        }
        case 1: {
            errorToast(setCtx, "addEventFormNotFilled", "Kunne ikke legge til arrangement", "Noen påkrevde felter er ikke fylt inn", undefined);
            dispatch(new Msg(3, [false]));
            break;
        }
    }
}

function Hero(heroInputProps) {
    let elems, el_2;
    const course = heroInputProps.course;
    const matchValue = bind((c) => orElse(c.ImageUrl, c.ThumbnailUrl), course);
    let matchResult, url_1;
    if (matchValue != null) {
        if (!isNullOrWhiteSpace(matchValue)) {
            matchResult = 0;
            url_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const el = Image;
            return createElement(el, {
                style: {
                    display: "block",
                    width: 100 + "%",
                    height: 180,
                    objectFit: "cover",
                    flexShrink: 0,
                },
                src: url_1,
                fit: "cover",
            });
        }
        default:
            return createElement("div", createObj(ofArray([["style", {
                height: 180,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: tokens.colorNeutralBackground3,
                flexShrink: 0,
            }], (elems = [(el_2 = CalendarLtrRegular, createElement(el_2, {
                style: {
                    fontSize: 96 + "px",
                },
                primaryFill: tokens.colorNeutralForeground3,
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

function SectionEyebrow(sectionEyebrowInputProps) {
    const label = sectionEyebrowInputProps.label;
    const el = Caption1Strong;
    return createElement(el, {
        style: {
            display: "block",
            textTransform: "uppercase",
            letterSpacing: "0.6px",
            color: tokens.colorNeutralForeground3,
            marginTop: 4,
        },
        children: label,
    });
}

export function Dialog(dialogInputProps) {
    let elems_53, el_4, el_2, el, el_127, elems_52, elems_49, el_117, elems_48, el_8, elems, el_6, el_115, elems_47, elems_51, el_119, el_125, elems_50, elemsToUse;
    const appendEvent = dialogInputProps.appendEvent;
    const triggerText = dialogInputProps.triggerText;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const selectedCourse = bind((p) => bind((f) => tryFind((c) => (c.Id === f.CourseId), p.AllCourses), model_1.Form), model_1.Prerequisites);
    const titleText = (selectedCourse == null) ? "Opprett et nytt arrangement" : (`Nytt arrangement · ${selectedCourse.Name}`);
    let canSubmit;
    const matchValue = model_1.Form;
    if (matchValue != null) {
        const form = matchValue;
        canSubmit = ((((((((((((!isNullOrWhiteSpace(form.Name) && !isNullOrWhiteSpace(form.Summary)) && (form.Summary.length <= 200)) && !defaultArg(map((d) => (d.length > 5000), form.Description), false)) && !defaultArg(map(isNullOrWhiteSpace, form.Address), true)) && (form.MaxAttendees > 0)) && (form.MaxAttendees <= 1000)) && (form.TeacherId != null)) && (form.RegionId != null)) && (compare(form.Time, now()) > 0)) && (compare(form.SignupDeadline, form.Time) < 0)) && (compare(form.SignupDeadline, now()) > 0)) && !model_1.IsSending);
    }
    else {
        canSubmit = false;
    }
    const el_129 = Dialog_1;
    return createElement(el_129, createObj(ofArray([["open", model_1.IsOpen], ["onOpenChange", (_arg, value_1_2) => {
        dispatch(new Msg(2, [value_1_2.open]));
    }], (elems_53 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = AddRegular, createElement(el, {})),
            appearance: "primary",
            children: triggerText,
            onClick: (_arg_1) => {
                if (model_1.Prerequisites == null) {
                    Promises_fetchPrerequisites(dispatch, setCtx);
                }
            },
        })),
    })), (el_127 = DialogSurface, createElement(el_127, createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["padding", 0]), delay(() => append(singleton(["overflow", "hidden"]), delay(() => append(singleton(["maxHeight", 90 + "vh"]), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => (isMobile ? singleton(["width", 95 + "vw"]) : append(singleton(["minWidth", 720]), delay(() => singleton(["maxWidth", 760])))))))))))))))))], (elems_52 = [createElement(Hero, {
        course: unwrap(selectedCourse),
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0,
        overflowY: "auto",
    }], (elems_49 = [(el_117 = DialogBody, createElement(el_117, createObj(ofArray([["style", {
        padding: ((16 + "px ") + 18) + "px",
        gap: 14 + "px ",
    }], (elems_48 = [(el_8 = DialogTitle, createElement(el_8, createObj(singleton_1((elems = [(el_6 = Title3, createElement(el_6, {
        children: titleText,
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))]))))), (el_115 = DialogContent, createElement(el_115, createObj(ofArray([["style", {
        overflow: "visible",
    }], (elems_47 = toList(delay(() => {
        let elems_46, elems_6, elems_5, el_23, elems_39, elems_38, elems_45, elems_44, elems_41, el_108, elems_43, el_113, elems_1, el_10, el_12;
        const matchValue_1 = model_1.Prerequisites;
        if (matchValue_1 != null) {
            const prerequisites = matchValue_1;
            return singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 18 + "px ",
            }], (elems_46 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 8 + "px ",
            }], (elems_6 = [createElement(SectionEyebrow, {
                label: "Kurset",
            }), createElement("div", createObj(ofArray([["style", {
                minHeight: 70,
            }], (elems_5 = [(el_23 = Field, createElement(el_23, createObj(toList(delay(() => append(singleton(["label", "Kurs"]), delay(() => append(singleton(["required", true]), delay(() => {
                let el_14;
                return append((model_1.Form == null) ? append(singleton(["validationMessageIcon", (el_14 = InfoRegular, createElement(el_14, {}))]), delay(() => append(singleton(["validationMessage", "Start med å velge et kurs"]), delay(() => singleton(["validationState", "none"]))))) : empty(), delay(() => {
                    let matchValue_4, el_20, elems_3;
                    return singleton(["children", (matchValue_4 = tryHead([(el_20 = Dropdown, createElement(el_20, createObj(ofArray([["value", defaultArg(map((_arg_2) => _arg_2.Name, bind((form_1) => tryFind((course) => (course.Id === form_1.CourseId), prerequisites.AllCourses), model_1.Form)), "")], ["onOptionSelect", (_arg_4, value_1_13) => {
                        iterate((selected) => {
                            const selectedCourse_1 = tryFind((course_1) => (course_1.Name === selected), prerequisites.AllCourses);
                            const matchValue_2 = model_1.Form;
                            if (selectedCourse_1 != null) {
                                if (matchValue_2 != null) {
                                    const course_3 = selectedCourse_1;
                                    const form_2 = matchValue_2;
                                    dispatch(new Msg(0, [new NewEventForm(course_3.Name, false, course_3.Summary, form_2.Description, form_2.Address, form_2.MaxAttendees, form_2.Time, form_2.EndTime, form_2.SignupDeadline, form_2.TeacherId, form_2.SecondaryTeacherIds, course_3.Id, form_2.RegionId)]));
                                }
                                else {
                                    const course_2 = selectedCourse_1;
                                    dispatch(new Msg(0, [new NewEventForm(course_2.Name, false, course_2.Summary, undefined, undefined, 0, create(year(utcNow()), month(utcNow()) + 2, day(utcNow()), 17, 0, 0), create(year(utcNow()), month(utcNow()) + 2, day(utcNow()), 21, 0, 0), create(year(utcNow()), month(utcNow()) + 1, day(utcNow()), 17, 0, 0), ctx.User.Id, new Int32Array([]), course_2.Id, map((_arg_3) => _arg_3.Region.Id, ctx.User.Workplace))]));
                                }
                            }
                        }, toArray(value_1_13.optionValue));
                    }], (elems_3 = toList(delay(() => map_1((course_4) => {
                        let elems_2, el_16;
                        const el_18 = Option;
                        return createElement(el_18, createObj(ofArray([["value", course_4.Name], ["text", course_4.Name], (elems_2 = [(el_16 = Text$, createElement(el_16, {
                            children: course_4.Name,
                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
                    }, sortBy((_arg_5) => _arg_5.Name, prerequisites.AllCourses, {
                        Compare: comparePrimitives,
                    })))), ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))]), (matchValue_4 == null) ? defaultOf() : matchValue_4)]);
                }));
            })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 8 + "px ",
                paddingTop: 14,
                borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
            }], (elems_39 = [createElement(SectionEyebrow, {
                label: "Detaljer",
            }), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(isMobile ? append(singleton(["flexDirection", "column"]), delay(() => singleton(["gap", 10 + "px "]))) : singleton(["flexDirection", "row"]), delay(() => singleton(["width", 100 + "%"]))))))))], (elems_38 = toList(delay(() => {
                let elems_17, elems_10, el_32, matchValue_5, el_29, elems_8, elems_12, el_37, matchValue_7, el_34, elems_14, el_42, elems_16, el_47;
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 10 + "px ",
                    minWidth: 280,
                }], (elems_17 = [createElement("div", createObj(ofArray([["style", {
                    height: 70,
                }], (elems_10 = [(el_32 = Field, createElement(el_32, {
                    label: "Region",
                    required: true,
                    children: (matchValue_5 = tryHead([(el_29 = Dropdown, createElement(el_29, createObj(ofArray([["disabled", model_1.Form == null], ["value", defaultArg(map((_arg_6) => _arg_6.Name, bind((form_3) => tryFind((region) => equals(region.Id, form_3.RegionId), prerequisites.AllRegions), model_1.Form)), "")], ["onOptionSelect", (_arg_8, value_1_20) => {
                        iterate((selected_1) => {
                            const selectedRegionId = map((_arg_7) => _arg_7.Id, tryFind((region_1) => (region_1.Name === selected_1), prerequisites.AllRegions));
                            iterate((form_4) => {
                                dispatch(new Msg(0, [new NewEventForm(form_4.Name, form_4.Enabled, form_4.Summary, form_4.Description, form_4.Address, form_4.MaxAttendees, form_4.Time, form_4.EndTime, form_4.SignupDeadline, form_4.TeacherId, form_4.SecondaryTeacherIds, form_4.CourseId, selectedRegionId)]));
                            }, toArray(model_1.Form));
                        }, toArray(value_1_20.optionValue));
                    }], (elems_8 = toList(delay(() => map_1((region_2) => {
                        let elems_7, el_25;
                        const el_27 = Option;
                        return createElement(el_27, createObj(ofArray([["value", region_2.Name], ["text", region_2.Name], (elems_7 = [(el_25 = Text$, createElement(el_25, {
                            children: region_2.Name,
                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])])));
                    }, sortBy((_arg_9) => _arg_9.Name, prerequisites.AllRegions, {
                        Compare: comparePrimitives,
                    })))), ["children", reactApi_1.Children.toArray(Array.from(elems_8))])]))))]), (matchValue_5 == null) ? defaultOf() : matchValue_5),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))), createElement("div", createObj(ofArray([["style", {
                    height: 70,
                }], (elems_12 = [(el_37 = Field, createElement(el_37, {
                    label: "Antall plasser",
                    required: true,
                    children: (matchValue_7 = tryHead([(el_34 = SpinButton, createElement(el_34, createObj(toList(delay(() => append(singleton(["style", {
                        minWidth: 250,
                    }]), delay(() => {
                        const matchValue_6 = model_1.Form;
                        if (matchValue_6 != null) {
                            const form_5 = matchValue_6;
                            return append(singleton(["value", form_5.MaxAttendees]), delay(() => append(singleton(["min", 0]), delay(() => append(singleton(["max", 1000]), delay(() => singleton(["onChange", (_arg_10, value_1_30) => {
                                const d_2 = value_1_30;
                                iterate((maxAttendees) => {
                                    dispatch(new Msg(0, [new NewEventForm(form_5.Name, form_5.Enabled, form_5.Summary, form_5.Description, form_5.Address, (maxAttendees < 1000) ? maxAttendees : 1000, form_5.Time, form_5.EndTime, form_5.SignupDeadline, form_5.TeacherId, form_5.SecondaryTeacherIds, form_5.CourseId, form_5.RegionId)]));
                                }, toArray(orElseWith(d_2.value, () => {
                                    if (isNullOrWhiteSpace(d_2.displayValue)) {
                                        return undefined;
                                    }
                                    else if (forAll(isNumber, d_2.displayValue.split(""))) {
                                        return parse(d_2.displayValue, 511, false, 32);
                                    }
                                    else {
                                        return undefined;
                                    }
                                })));
                            }])))))));
                        }
                        else {
                            return append(singleton(["disabled", true]), delay(() => singleton(["value", 0])));
                        }
                    })))))))]), (matchValue_7 == null) ? defaultOf() : matchValue_7),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))), createElement("div", createObj(ofArray([["style", {
                    height: 70,
                }], (elems_14 = [(el_42 = Field, createElement(el_42, createObj(toList(delay(() => append(singleton(["label", "Adresse"]), delay(() => append(singleton(["required", true]), delay(() => {
                    let matchValue_8, matchValue_9, address_1;
                    return append((matchValue_8 = model_1.Form, (matchValue_8 != null) ? ((matchValue_9 = matchValue_8.Address, (matchValue_9 != null) ? (isNullOrWhiteSpace(matchValue_9) ? ((address_1 = matchValue_9, append(singleton(["validationMessage", "Adressefelt kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))))) : (empty())) : (empty()))) : (empty())), delay(() => {
                        let matchValue_11;
                        return singleton(["children", (matchValue_11 = tryHead(toList(delay(() => {
                            let el_39;
                            const matchValue_10 = model_1.Form;
                            if (matchValue_10 != null) {
                                const form_7 = matchValue_10;
                                return singleton(createElement(Component, {
                                    value: defaultArg(form_7.Address, ""),
                                    onChange: (v_2) => {
                                        dispatch(new Msg(0, [new NewEventForm(form_7.Name, form_7.Enabled, form_7.Summary, form_7.Description, v_2, form_7.MaxAttendees, form_7.Time, form_7.EndTime, form_7.SignupDeadline, form_7.TeacherId, form_7.SecondaryTeacherIds, form_7.CourseId, form_7.RegionId)]));
                                    },
                                    placeholder: "Skriv inn adresse…",
                                    disabled: false,
                                }));
                            }
                            else {
                                return singleton((el_39 = Input, createElement(el_39, {
                                    style: {
                                        minWidth: 250,
                                    },
                                    disabled: true,
                                    value: "",
                                })));
                            }
                        }))), (matchValue_11 == null) ? defaultOf() : matchValue_11)]);
                    }));
                })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_14))])]))), createElement("div", createObj(ofArray([["style", {
                    height: 70,
                }], (elems_16 = [(el_47 = Field, createElement(el_47, createObj(toList(delay(() => append(singleton(["label", "Publiser"]), delay(() => {
                    let matchValue_12, form_9;
                    return append((matchValue_12 = model_1.Form, (matchValue_12 != null) ? (matchValue_12.Enabled ? ((form_9 = matchValue_12, singleton(["hint", "Arrangementet publiseres med en gang, og blir synlig for alle"]))) : singleton(["hint", "Arrangementet lagres som utkast, og blir ikke synlig for alle"])) : singleton(["hint", "Arrangementet lagres som utkast, og blir ikke synlig for alle"])), delay(() => {
                        let matchValue_14, el_44;
                        return singleton(["children", (matchValue_14 = tryHead([(el_44 = Switch, createElement(el_44, createObj(toList(delay(() => {
                            const matchValue_13 = model_1.Form;
                            if (matchValue_13 != null) {
                                const form_10 = matchValue_13;
                                return append(singleton(["checked", form_10.Enabled]), delay(() => singleton(["onChange", (_arg_11, value_1_42) => {
                                    dispatch(new Msg(0, [new NewEventForm(form_10.Name, value_1_42.checked, form_10.Summary, form_10.Description, form_10.Address, form_10.MaxAttendees, form_10.Time, form_10.EndTime, form_10.SignupDeadline, form_10.TeacherId, form_10.SecondaryTeacherIds, form_10.CourseId, form_10.RegionId)]));
                                }])));
                            }
                            else {
                                return append(singleton(["disabled", true]), delay(() => singleton(["checked", false])));
                            }
                        })))))]), (matchValue_14 == null) ? defaultOf() : matchValue_14)]);
                    }));
                })))))))], ["children", reactApi.Children.toArray(Array.from(elems_16))])])))], ["children", reactApi.Children.toArray(Array.from(elems_17))])])))), delay(() => {
                    let el_49;
                    return append(!isMobile ? singleton((el_49 = Divider, createElement(el_49, {
                        vertical: true,
                    }))) : empty(), delay(() => {
                        let elems_37, elems_19, el_54, elems_23, el_67, elems_28, el_80, matchValue_23, elems_30, el_85, elems_31, el_89, el_87, elems_33, el_94, elems_34, el_98, el_96, elems_36, el_103;
                        return singleton(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => append(singleton(["gap", 10 + "px "]), delay(() => (!isMobile ? singleton(["width", 280]) : empty()))))))))))], (elems_37 = [createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_19 = [(el_54 = Field, createElement(el_54, createObj(toList(delay(() => append(singleton(["label", "Navn"]), delay(() => append(singleton(["required", true]), delay(() => {
                            let matchValue_15, form_12;
                            return append((matchValue_15 = model_1.Form, (matchValue_15 != null) ? (isNullOrWhiteSpace(matchValue_15.Name) ? ((form_12 = matchValue_15, append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))))) : (empty())) : (empty())), delay(() => {
                                let matchValue_17, el_51;
                                return singleton(["children", (matchValue_17 = tryHead([(el_51 = Input, createElement(el_51, createObj(toList(delay(() => append(singleton(["style", {
                                    minWidth: 250,
                                }]), delay(() => {
                                    const matchValue_16 = model_1.Form;
                                    if (matchValue_16 != null) {
                                        const form_13 = matchValue_16;
                                        return append(singleton(["value", form_13.Name]), delay(() => singleton(["onChange", (_arg_12, value_1_50) => {
                                            dispatch(new Msg(0, [new NewEventForm(value_1_50.value, form_13.Enabled, form_13.Summary, form_13.Description, form_13.Address, form_13.MaxAttendees, form_13.Time, form_13.EndTime, form_13.SignupDeadline, form_13.TeacherId, form_13.SecondaryTeacherIds, form_13.CourseId, form_13.RegionId)]));
                                        }])));
                                    }
                                    else {
                                        return append(singleton(["disabled", true]), delay(() => singleton(["value", ""])));
                                    }
                                })))))))]), (matchValue_17 == null) ? defaultOf() : matchValue_17)]);
                            }));
                        })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_19))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_23 = [(el_67 = Field, createElement(el_67, createObj(toList(delay(() => append(singleton(["label", "Kursholder"]), delay(() => append(singleton(["required", true]), delay(() => {
                            let matchValue_18, form_15;
                            return append((matchValue_18 = model_1.Form, (matchValue_18 != null) ? ((matchValue_18.TeacherId == null) ? ((form_15 = matchValue_18, append(singleton(["validationMessage", "Arrangementet må ha en kursholder"]), delay(() => singleton(["validationState", "error"]))))) : (empty())) : (empty())), delay(() => {
                                let matchValue_21;
                                return singleton(["children", (matchValue_21 = tryHead(toList(delay(() => {
                                    let el_64, elems_21, elems_20, el_56, el_58, el_62, el_60;
                                    const matchValue_19 = model_1.Form;
                                    if (matchValue_19 == null) {
                                        return singleton((el_64 = Combobox, createElement(el_64, {
                                            disabled: true,
                                        })));
                                    }
                                    else {
                                        const form_16 = matchValue_19;
                                        const matchValue_20 = tryFind((user) => equals(user.Id, form_16.TeacherId), prerequisites.AllValidTeachers);
                                        if (matchValue_20 != null) {
                                            const teacher$0027 = matchValue_20;
                                            return singleton(createElement("div", createObj(ofArray([["style", {
                                                display: "flex",
                                                justifyContent: "space-between",
                                                minWidth: 250,
                                            }], (elems_21 = [createElement("div", createObj(ofArray([["style", {
                                                display: "flex",
                                                gap: 5 + "px ",
                                                alignItems: "center",
                                            }], (elems_20 = [(el_56 = Avatar, createElement(el_56, {
                                                color: "colorful",
                                                image: {
                                                    src: defaultArg(teacher$0027.ThumbnailUrl, ""),
                                                },
                                                name: `${teacher$0027.FirstName} ${teacher$0027.LastName}`,
                                            })), (el_58 = Text$, createElement(el_58, {
                                                children: `${teacher$0027.FirstName} ${teacher$0027.LastName}`,
                                            }))], ["children", reactApi.Children.toArray(Array.from(elems_20))])]))), (el_62 = Button, createElement(el_62, {
                                                appearance: "transparent",
                                                icon: (el_60 = DismissRegular, createElement(el_60, {})),
                                                onClick: (_arg_13) => {
                                                    dispatch(new Msg(0, [new NewEventForm(form_16.Name, form_16.Enabled, form_16.Summary, form_16.Description, form_16.Address, form_16.MaxAttendees, form_16.Time, form_16.EndTime, form_16.SignupDeadline, undefined, form_16.SecondaryTeacherIds, form_16.CourseId, form_16.RegionId)]));
                                                },
                                            }))], ["children", reactApi.Children.toArray(Array.from(elems_21))])]))));
                                        }
                                        else {
                                            return singleton(createElement(UserSearchBox, {
                                                users: prerequisites.AllValidTeachers,
                                                callback: (user_1) => {
                                                    dispatch(new Msg(0, [new NewEventForm(form_16.Name, form_16.Enabled, form_16.Summary, form_16.Description, form_16.Address, form_16.MaxAttendees, form_16.Time, form_16.EndTime, form_16.SignupDeadline, user_1.Id, form_16.SecondaryTeacherIds, form_16.CourseId, form_16.RegionId)]));
                                                },
                                            }));
                                        }
                                    }
                                }))), (matchValue_21 == null) ? defaultOf() : matchValue_21)]);
                            }));
                        })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_23))])]))), createElement("div", createObj(ofArray([["style", {
                            minHeight: 100,
                            width: 100 + "%",
                        }], (elems_28 = [(el_80 = Field, createElement(el_80, {
                            label: "Sekundære kursholdere (valgfritt)",
                            children: (matchValue_23 = tryHead(toList(delay(() => {
                                let el_77, elems_26;
                                const matchValue_22 = model_1.Form;
                                if (matchValue_22 == null) {
                                    return singleton((el_77 = Text$, createElement(el_77, {
                                        children: "Velg et kurs først",
                                    })));
                                }
                                else {
                                    const form_17 = matchValue_22;
                                    const selectedSecondaryTeachers = prerequisites.AllValidTeachers.filter((user_2) => contains(user_2.Id, form_17.SecondaryTeacherIds, {
                                        Equals: (x_2, y_2) => (x_2 === y_2),
                                        GetHashCode: numberHash,
                                    }));
                                    return singleton(createElement("div", createObj(ofArray([["style", {
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 5 + "px ",
                                    }], (elems_26 = toList(delay(() => append(map_2((teacher_1) => {
                                        let elems_25, elems_24, el_69, el_71, el_75, el_73;
                                        return createElement("div", createObj(ofArray([["style", {
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            backgroundColor: tokens.colorNeutralBackground1,
                                        }], (elems_25 = [createElement("div", createObj(ofArray([["style", {
                                            display: "flex",
                                            gap: 8 + "px ",
                                            alignItems: "center",
                                        }], (elems_24 = [(el_69 = Avatar, createElement(el_69, {
                                            color: "colorful",
                                            size: 28,
                                            image: {
                                                src: defaultArg(teacher_1.ThumbnailUrl, ""),
                                            },
                                            name: `${teacher_1.FirstName} ${teacher_1.LastName}`,
                                        })), (el_71 = Text$, createElement(el_71, {
                                            children: `${teacher_1.FirstName} ${teacher_1.LastName}`,
                                        }))], ["children", reactApi.Children.toArray(Array.from(elems_24))])]))), (el_75 = Button, createElement(el_75, {
                                            appearance: "transparent",
                                            icon: (el_73 = DismissRegular, createElement(el_73, {})),
                                            onClick: (_arg_14) => {
                                                dispatch(new Msg(0, [new NewEventForm(form_17.Name, form_17.Enabled, form_17.Summary, form_17.Description, form_17.Address, form_17.MaxAttendees, form_17.Time, form_17.EndTime, form_17.SignupDeadline, form_17.TeacherId, form_17.SecondaryTeacherIds.filter((id) => (id !== teacher_1.Id)), form_17.CourseId, form_17.RegionId)]));
                                            },
                                        }))], ["children", reactApi.Children.toArray(Array.from(elems_25))])])));
                                    }, selectedSecondaryTeachers), delay(() => {
                                        const availableTeachers = prerequisites.AllValidTeachers.filter((user_3) => {
                                            if (!contains(user_3.Id, form_17.SecondaryTeacherIds, {
                                                Equals: (x_3, y_3) => (x_3 === y_3),
                                                GetHashCode: numberHash,
                                            })) {
                                                return !equals(user_3.Id, form_17.TeacherId);
                                            }
                                            else {
                                                return false;
                                            }
                                        });
                                        return (availableTeachers.length > 0) ? singleton(createElement(UserSearchBox, {
                                            users: availableTeachers,
                                            callback: (user_4) => {
                                                dispatch(new Msg(0, [new NewEventForm(form_17.Name, form_17.Enabled, form_17.Summary, form_17.Description, form_17.Address, form_17.MaxAttendees, form_17.Time, form_17.EndTime, form_17.SignupDeadline, form_17.TeacherId, append_1(form_17.SecondaryTeacherIds, new Int32Array([user_4.Id]), Int32Array), form_17.CourseId, form_17.RegionId)]));
                                            },
                                        })) : empty();
                                    })))), ["children", reactApi.Children.toArray(Array.from(elems_26))])]))));
                                }
                            }))), (matchValue_23 == null) ? defaultOf() : matchValue_23),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_28))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_30 = [(el_85 = Field, createElement(el_85, createObj(toList(delay(() => append(singleton(["label", "Startdato"]), delay(() => append(singleton(["required", true]), delay(() => {
                            let matchValue_24, form_19;
                            return append((matchValue_24 = model_1.Form, (matchValue_24 != null) ? ((compare(matchValue_24.Time, now()) <= 0) ? ((form_19 = matchValue_24, append(singleton(["validationMessage", "Arrangement kan ikke være i fortiden"]), delay(() => singleton(["validationState", "error"]))))) : (empty())) : (empty())), delay(() => {
                                let matchValue_26, el_82;
                                return singleton(["children", (matchValue_26 = tryHead([(el_82 = DatePicker, createElement(el_82, createObj(toList(delay(() => append(singleton(["strings", datePickerStrings]), delay(() => append(singleton(["firstDayOfWeek", 1]), delay(() => append(singleton(["formatDate", (delegateArg) => {
                                    const locale = nb;
                                    const formatOptions = {};
                                    formatOptions.locale = locale;
                                    return format_3(delegateArg, "EEEE dd MMMM yyyy", formatOptions);
                                }]), delay(() => append(singleton(["minDate", setHours(utcNow(), 0)]), delay(() => {
                                    const matchValue_25 = model_1.Form;
                                    if (matchValue_25 != null) {
                                        const form_20 = matchValue_25;
                                        return append(singleton(["value", form_20.Time]), delay(() => singleton(["onSelectDate", (delegateArg_1) => {
                                            iterate((date_2) => {
                                                dispatch(new Msg(0, [new NewEventForm(form_20.Name, form_20.Enabled, form_20.Summary, form_20.Description, form_20.Address, form_20.MaxAttendees, create(year(date_2), month(date_2), day(date_2), hour(form_20.Time), minute(form_20.Time), 0), form_20.EndTime, form_20.SignupDeadline, form_20.TeacherId, form_20.SecondaryTeacherIds, form_20.CourseId, form_20.RegionId)]));
                                            }, toArray(delegateArg_1));
                                        }])));
                                    }
                                    else {
                                        return append(singleton(["disabled", true]), delay(() => singleton(["value", utcNow()])));
                                    }
                                })))))))))))))]), (matchValue_26 == null) ? defaultOf() : matchValue_26)]);
                            }));
                        })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_30))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_31 = [(el_89 = Field, createElement(el_89, {
                            required: true,
                            label: "Starttidspunkt",
                            children: (el_87 = TimePicker, createElement(el_87, createObj(toList(delay(() => append(singleton(["hourCycle", "h23"]), delay(() => append(singleton(["increment", 15]), delay(() => append(singleton(["placeholder", "Velg et tidspunkt..."]), delay(() => append(singleton(["value", defaultArg(map((f_1) => toString(f_1.Time, "HH:mm"), model_1.Form), "")]), delay(() => {
                                const matchValue_27 = model_1.Form;
                                if (matchValue_27 != null) {
                                    const form_21 = matchValue_27;
                                    return append(singleton(["selectedTime", form_21.Time]), delay(() => singleton(["onTimeChange", (_arg_16, value_1_82) => {
                                        iterate((time) => {
                                            dispatch(new Msg(0, [new NewEventForm(form_21.Name, form_21.Enabled, form_21.Summary, form_21.Description, form_21.Address, form_21.MaxAttendees, create(year(form_21.Time), month(form_21.Time), day(form_21.Time), hour(time), minute(time), 0), form_21.EndTime, form_21.SignupDeadline, form_21.TeacherId, form_21.SecondaryTeacherIds, form_21.CourseId, form_21.RegionId)]));
                                        }, toArray(TimeSelectionDataModule_parse(value_1_82).selectedTime));
                                    }])));
                                }
                                else {
                                    return append(singleton(["selectedTime", now()]), delay(() => singleton(["disabled", true])));
                                }
                            }))))))))))))),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_31))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_33 = [(el_94 = Field, createElement(el_94, createObj(toList(delay(() => append(singleton(["label", "Sluttdato"]), delay(() => append(singleton(["required", true]), delay(() => {
                            let matchValue_28, form_22, form_23;
                            return append((matchValue_28 = model_1.Form, (matchValue_28 != null) ? (((form_22 = matchValue_28, compare(form_22.Time, form_22.EndTime) > 0)) ? ((form_23 = matchValue_28, append(singleton(["validationMessage", "Sluttdato må være etter startdato"]), delay(() => singleton(["validationState", "error"]))))) : (empty())) : (empty())), delay(() => {
                                let matchValue_30, el_91;
                                return singleton(["children", (matchValue_30 = tryHead([(el_91 = DatePicker, createElement(el_91, createObj(toList(delay(() => append(singleton(["strings", datePickerStrings]), delay(() => append(singleton(["firstDayOfWeek", 1]), delay(() => append(singleton(["formatDate", (delegateArg_2) => {
                                    const locale_1 = nb;
                                    const formatOptions_1 = {};
                                    formatOptions_1.locale = locale_1;
                                    return format_3(delegateArg_2, "EEEE dd MMMM yyyy", formatOptions_1);
                                }]), delay(() => {
                                    const matchValue_29 = model_1.Form;
                                    if (matchValue_29 != null) {
                                        const form_24 = matchValue_29;
                                        return append(singleton(["minDate", form_24.Time]), delay(() => append(singleton(["value", form_24.EndTime]), delay(() => singleton(["onSelectDate", (delegateArg_3) => {
                                            iterate((date_4) => {
                                                dispatch(new Msg(0, [new NewEventForm(form_24.Name, form_24.Enabled, form_24.Summary, form_24.Description, form_24.Address, form_24.MaxAttendees, form_24.Time, create(year(date_4), month(date_4), day(date_4), hour(form_24.EndTime), minute(form_24.EndTime), 0), form_24.SignupDeadline, form_24.TeacherId, form_24.SecondaryTeacherIds, form_24.CourseId, form_24.RegionId)]));
                                            }, toArray(delegateArg_3));
                                        }])))));
                                    }
                                    else {
                                        return append(singleton(["disabled", true]), delay(() => singleton(["value", utcNow()])));
                                    }
                                })))))))))))]), (matchValue_30 == null) ? defaultOf() : matchValue_30)]);
                            }));
                        })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_33))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_34 = [(el_98 = Field, createElement(el_98, {
                            required: true,
                            label: "Slutttidspunkt",
                            children: (el_96 = TimePicker, createElement(el_96, createObj(toList(delay(() => append(singleton(["hourCycle", "h23"]), delay(() => append(singleton(["increment", 15]), delay(() => append(singleton(["placeholder", "Velg et tidspunkt..."]), delay(() => append(singleton(["value", defaultArg(map((f_2) => toString(f_2.EndTime, "HH:mm"), model_1.Form), "")]), delay(() => {
                                const matchValue_31 = model_1.Form;
                                if (matchValue_31 != null) {
                                    const form_25 = matchValue_31;
                                    return append(singleton(["selectedTime", form_25.EndTime]), delay(() => singleton(["onTimeChange", (_arg_18, value_1_102) => {
                                        iterate((time_1) => {
                                            dispatch(new Msg(0, [new NewEventForm(form_25.Name, form_25.Enabled, form_25.Summary, form_25.Description, form_25.Address, form_25.MaxAttendees, form_25.Time, create(year(form_25.EndTime), month(form_25.EndTime), day(form_25.EndTime), hour(time_1), minute(time_1), 0), form_25.SignupDeadline, form_25.TeacherId, form_25.SecondaryTeacherIds, form_25.CourseId, form_25.RegionId)]));
                                        }, toArray(TimeSelectionDataModule_parse(value_1_102).selectedTime));
                                    }])));
                                }
                                else {
                                    return append(singleton(["selectedTime", now()]), delay(() => singleton(["disabled", true])));
                                }
                            }))))))))))))),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_34))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_36 = [(el_103 = Field, createElement(el_103, createObj(toList(delay(() => append(singleton(["label", "Påmeldingsfrist"]), delay(() => append(singleton(["required", true]), delay(() => {
                            let matchValue_32, form_26;
                            return append((matchValue_32 = model_1.Form, (matchValue_32 != null) ? ((form_26 = matchValue_32, (compare(form_26.SignupDeadline, now()) <= 0) ? append(singleton(["validationMessage", "Frist kan ikke være i fortiden"]), delay(() => singleton(["validationState", "error"]))) : ((compare(form_26.SignupDeadline, form_26.Time) >= 0) ? append(singleton(["validationMessage", "Frist kan ikke være etter arrangementet"]), delay(() => singleton(["validationState", "error"]))) : singleton(["hint", "Påmeldte brukere blir varslet om sikret plass / venteliste når denne fristen utløper"])))) : (empty())), delay(() => {
                                let matchValue_34, el_100;
                                return singleton(["children", (matchValue_34 = tryHead([(el_100 = DatePicker, createElement(el_100, createObj(toList(delay(() => append(singleton(["strings", datePickerStrings]), delay(() => append(singleton(["firstDayOfWeek", 1]), delay(() => append(singleton(["formatDate", (delegateArg_4) => {
                                    const locale_2 = nb;
                                    const formatOptions_2 = {};
                                    formatOptions_2.locale = locale_2;
                                    return format_3(delegateArg_4, "EEEE dd MMMM yyyy", formatOptions_2);
                                }]), delay(() => append(singleton(["minDate", setHours(utcNow(), 0)]), delay(() => {
                                    const matchValue_33 = model_1.Form;
                                    if (matchValue_33 != null) {
                                        const form_27 = matchValue_33;
                                        return append(singleton(["maxDate", form_27.Time]), delay(() => append(singleton(["value", form_27.SignupDeadline]), delay(() => singleton(["onSelectDate", (delegateArg_5) => {
                                            iterate((date_7) => {
                                                dispatch(new Msg(0, [new NewEventForm(form_27.Name, form_27.Enabled, form_27.Summary, form_27.Description, form_27.Address, form_27.MaxAttendees, form_27.Time, form_27.EndTime, create(year(date_7), month(date_7), day(date_7), hour(form_27.Time), minute(form_27.Time), 0), form_27.TeacherId, form_27.SecondaryTeacherIds, form_27.CourseId, form_27.RegionId)]));
                                            }, toArray(delegateArg_5));
                                        }])))));
                                    }
                                    else {
                                        return append(singleton(["disabled", true]), delay(() => singleton(["value", utcNow()])));
                                    }
                                })))))))))))))]), (matchValue_34 == null) ? defaultOf() : matchValue_34)]);
                            }));
                        })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_36))])])))], ["children", reactApi.Children.toArray(Array.from(elems_37))])]))));
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_38))])])))], ["children", reactApi.Children.toArray(Array.from(elems_39))])]))), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 8 + "px ",
                paddingTop: 14,
                borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
            }], (elems_45 = [createElement(SectionEyebrow, {
                label: "Beskrivelse",
            }), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 10 + "px ",
                width: 100 + "%",
            }], (elems_44 = [createElement("div", createObj(ofArray([["style", {
                minHeight: 100,
            }], (elems_41 = [(el_108 = Field, createElement(el_108, createObj(toList(delay(() => append(singleton(["label", "Sammendrag"]), delay(() => append(singleton(["required", true]), delay(() => {
                let matchValue_35, form_28;
                return append((matchValue_35 = model_1.Form, (matchValue_35 != null) ? ((form_28 = matchValue_35, isNullOrWhiteSpace(form_28.Summary) ? append(singleton(["validationMessage", "Sammendrag kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : ((form_28.Summary.length > 200) ? append(singleton(["validationMessage", `Sammendrag kan ikke være lengre enn 200 tegn (${form_28.Summary.length}/200)`]), delay(() => singleton(["validationState", "error"]))) : append(singleton(["validationMessage", `${form_28.Summary.length}/200`]), delay(() => singleton(["validationState", "none"])))))) : (empty())), delay(() => {
                    let matchValue_37, el_105;
                    return singleton(["children", (matchValue_37 = tryHead([(el_105 = Textarea, createElement(el_105, createObj(toList(delay(() => append(singleton(["resize", "vertical"]), delay(() => {
                        const matchValue_36 = model_1.Form;
                        if (matchValue_36 != null) {
                            const form_29 = matchValue_36;
                            return append(singleton(["value", form_29.Summary]), delay(() => singleton(["onChange", (_arg_20, value_1_125) => {
                                dispatch(new Msg(0, [new NewEventForm(form_29.Name, form_29.Enabled, value_1_125.value, form_29.Description, form_29.Address, form_29.MaxAttendees, form_29.Time, form_29.EndTime, form_29.SignupDeadline, form_29.TeacherId, form_29.SecondaryTeacherIds, form_29.CourseId, form_29.RegionId)]));
                            }])));
                        }
                        else {
                            return append(singleton(["disabled", true]), delay(() => singleton(["value", ""])));
                        }
                    })))))))]), (matchValue_37 == null) ? defaultOf() : matchValue_37)]);
                }));
            })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_41))])]))), createElement("div", createObj(ofArray([["style", {
                minHeight: 200,
            }], (elems_43 = [(el_113 = Field, createElement(el_113, createObj(toList(delay(() => append(singleton(["label", "Kommentar fra kursholder"]), delay(() => append(defaultArg(map((description) => {
                if (description.length > 5000) {
                    return ofArray([["validationMessage", `Kommentar kan ikke være lengre enn 5000 tegn (${description.length}/5000)`], ["validationState", "error"]]);
                }
                else {
                    return ofArray([["validationMessage", `${description.length}/5000`], ["validationState", "none"]]);
                }
            }, bind((_arg_21) => _arg_21.Description, model_1.Form)), empty_1()), delay(() => {
                let matchValue_39, el_110;
                return singleton(["children", (matchValue_39 = tryHead([(el_110 = Textarea, createElement(el_110, createObj(toList(delay(() => append(singleton(["resize", "vertical"]), delay(() => append(singleton(["style", {
                    minHeight: 150,
                }]), delay(() => {
                    const matchValue_38 = model_1.Form;
                    if (matchValue_38 != null) {
                        const form_30 = matchValue_38;
                        return append(singleton(["value", defaultArg(form_30.Description, "")]), delay(() => singleton(["onChange", (_arg_22, value_1_132) => {
                            dispatch(new Msg(0, [new NewEventForm(form_30.Name, form_30.Enabled, form_30.Summary, value_1_132.value, form_30.Address, form_30.MaxAttendees, form_30.Time, form_30.EndTime, form_30.SignupDeadline, form_30.TeacherId, form_30.SecondaryTeacherIds, form_30.CourseId, form_30.RegionId)]));
                        }])));
                    }
                    else {
                        return append(singleton(["disabled", true]), delay(() => singleton(["value", ""])));
                    }
                })))))))))]), (matchValue_39 == null) ? defaultOf() : matchValue_39)]);
            })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_43))])])))], ["children", reactApi.Children.toArray(Array.from(elems_44))])])))], ["children", reactApi.Children.toArray(Array.from(elems_45))])])))], ["children", reactApi.Children.toArray(Array.from(elems_46))])]))));
        }
        else {
            return singleton(createElement("div", createObj(ofArray([["style", {
                width: 100 + "%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingBottom: 15,
            }], (elems_1 = [(el_10 = WarningRegular, createElement(el_10, {
                primaryFill: tokens.colorStatusWarningForeground1,
                fontSize: 82,
            })), (el_12 = Caption1, createElement(el_12, {
                children: "Noe gikk galt - vennligst prøv igjen senere",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        }
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_47))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_48))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_49))])]))), createElement("div", createObj(ofArray([["style", {
        padding: ((12 + "px ") + 18) + "px",
        borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
        backgroundColor: tokens.colorNeutralBackground1,
        display: "flex",
        justifyContent: "flex-end",
        gap: 8 + "px ",
        flexShrink: 0,
    }], (elems_51 = [(el_119 = Button, createElement(el_119, {
        appearance: "secondary",
        children: "Avbryt",
        disabled: model_1.IsSending,
        onClick: (_arg_23) => {
            dispatch(new Msg(2, [false]));
            dispatch(new Msg(0, [undefined]));
        },
    })), (el_125 = Button, createElement(el_125, createObj(ofArray([["appearance", "primary"], ["disabled", !canSubmit], ["onClick", (_arg_24) => {
        dispatch(new Msg(3, [true]));
        iterate((form_31) => {
            Promises_addEvent(form_31, appendEvent, dispatch, setCtx);
        }, toArray(model_1.Form));
    }], (elems_50 = toList(delay(() => {
        let el_121, el_123;
        return model_1.IsSending ? singleton((el_121 = Spinner, createElement(el_121, {
            size: "tiny",
        }))) : singleton((el_123 = Text$, createElement(el_123, {
            children: "Opprett",
        })));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_50))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_51))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_52))])]))))], (elemsToUse = ((length(elems_53) <= 2) ? elems_53 : take(2, elems_53)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

//# sourceMappingURL=AddEvent.jsx.map
